import React from "react";
import { Link } from "react-router-dom";
import CompetitorCard from "./CompetitorCard";

function CompetitorList({ competitors }) {
  if (!competitors || competitors.length === 0) {
    return <p className="text-gray-400 text-lg">No competitors found.</p>;
  }

  // Sort competitors by logo presence first, then alphabetically by name
  const sortedCompetitors = [...competitors].sort((a, b) => {
    if (a.logo && !b.logo) return -1;
    if (!a.logo && b.logo) return 1;
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 transition-opacity duration-300">
      {sortedCompetitors.map((competitor) => (
        <div
          key={competitor.id}
          className="transform transition-all duration-300 hover:scale-105 hover:shadow-lg"
        >
          <Link to={`/competitor/${encodeURIComponent(competitor.name.toLowerCase().replace(/\s+/g, "-"))}`}>
            <CompetitorCard competitor={competitor} isInternal />
          </Link>
        </div>
      ))}
    </div>
  );
}

export default CompetitorList;
